module.exports = __webpack_public_path__ + "img/icon_2_2.4c6d6a08.png";